"use strict";
/*
 * Created on 16.10.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var utils_1 = require("../../core/utils");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var Promotion_1 = require("../model/Promotion");

var PromotionWarningFlag_1 = require("../model/PromotionWarningFlag");

var ManualPromoWeekSplitConverter_1 = require("./ManualPromoWeekSplitConverter");

var PromotionConverter_1 = require("./PromotionConverter");
/**
 * @author MSu
 */


var PromotionConverterImpl =
/*#__PURE__*/
function (_PromotionConverter_) {
  _inherits(PromotionConverterImpl, _PromotionConverter_);

  function PromotionConverterImpl(userInfoConverter, manualPromoWeekSplitConverter) {
    var _this;

    _classCallCheck(this, PromotionConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    _this.manualPromoWeekSplitConverter = manualPromoWeekSplitConverter;
    return _this;
  }

  _createClass(PromotionConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new Promotion_1.Promotion(Promotion_1.Promotion.schema.id.valueOf(conversions.documentToClassId(source)), Promotion_1.Promotion.schema.externalId.valueOfField(source), Promotion_1.Promotion.schema.workflowCaseId.valueOf(conversions.toClassReferenceId(source.workflowCaseId)), Promotion_1.Promotion.schema.workflowState.valueOfField(source), Promotion_1.Promotion.schema.workflowModified.valueOfField(source), Promotion_1.Promotion.schema.name.valueOfField(source), Promotion_1.Promotion.schema.promotionTypeId.valueOf(conversions.toClassReferenceId(source.promotionTypeId)), Promotion_1.Promotion.schema.description.valueOfField(source), Promotion_1.Promotion.schema.dateFrom.valueOfField(source), Promotion_1.Promotion.schema.dateTo.valueOfField(source), Promotion_1.Promotion.schema.groupOfSitesId.valueOf(conversions.toClassReferenceId(source.groupOfSitesId)), !utils_1.Utils.isValueMissing(source.ecommerce) ? Promotion_1.Promotion.schema.ecommerce.valueOfField(source) : false, !utils_1.Utils.isValueMissing(source.opening) ? Promotion_1.Promotion.schema.opening.valueOfField(source) : false, Promotion_1.Promotion.schema.storeSpecification.valueOfField(source), Promotion_1.Promotion.schema.themeIds.valueOf(source.themeIds ? conversions.asObjectList(source, 'themeIds', function (value) {
        return conversions.toClassReferenceId(value);
      }) : null), Promotion_1.Promotion.schema.created.valueOfField(source), this.userInfoConverter.toObject(source.createdBy, conversions), Promotion_1.Promotion.schema.modified.valueOfField(source), this.userInfoConverter.toObject(source.modifiedBy, conversions), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag), Promotion_1.Promotion.schema.assignedMasterArea.valueOfField(source), Promotion_1.Promotion.schema.lastEffect.valueOfField(source), Promotion_1.Promotion.schema.promoSplitOption.valueOfField(source), Promotion_1.Promotion.schema.manualSplits.valueOf(conversions.asObjectList(source, 'manualSplits', function (s) {
        return _this2.manualPromoWeekSplitConverter.toObject(s, conversions);
      })), conversions.asFlagSet(source.warningFlags, PromotionWarningFlag_1.PromotionWarningFlag), Promotion_1.Promotion.schema.processed.valueOfField(source), Promotion_1.Promotion.schema.snapshotOriginId.valueOf(conversions.toClassReferenceId(source.snapshotOriginId)));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        workflowCaseId: conversions.toDocumentReferenceId(source.workflowCaseId),
        workflowState: source.workflowState,
        workflowModified: source.workflowModified !== null ? conversions.fromDate(source.workflowModified) : null,
        name: source.name,
        promotionTypeId: conversions.toDocumentReferenceId(source.promotionTypeId),
        description: source.description,
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        groupOfSitesId: conversions.toDocumentReferenceId(source.groupOfSitesId),
        ecommerce: source.ecommerce,
        opening: source.opening,
        storeSpecification: source.storeSpecification,
        themeIds: conversions.asObjectArray(source, 'themeIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        created: conversions.fromDate(source.created),
        createdBy: this.userInfoConverter.toDocument(source.createdBy, conversions),
        modified: conversions.fromDate(source.modified),
        modifiedBy: this.userInfoConverter.toDocument(source.modifiedBy, conversions),
        stateFlags: source.stateFlags.serialize(),
        assignedMasterArea: source.assignedMasterArea,
        lastEffect: conversions.fromDate(source.lastEffect),
        promoSplitOption: source.promoSplitOption,
        manualSplits: conversions.asObjectArray(source, 'manualSplits', function (s) {
          return _this3.manualPromoWeekSplitConverter.toDocument(s, conversions);
        }),
        warningFlags: source.warningFlags.serialize(),
        processed: source.processed,
        snapshotOriginId: conversions.toDocumentReferenceId(source.snapshotOriginId)
      });
      return result;
    }
  }]);

  return PromotionConverterImpl;
}(PromotionConverter_1.PromotionConverter);

PromotionConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter, ManualPromoWeekSplitConverter_1.ManualPromoWeekSplitConverter])], PromotionConverterImpl);
exports.PromotionConverterImpl = PromotionConverterImpl;